import {
  CustomInput,
  CustomSelect,
  CustomToggle,
  CustomSlider,
  CustomNumberInput
} from './CustomFormElements';
import { useEffect } from 'react';

function AgentSettings({
    name,
    detailsLevel,
    temperature,
    promptId,
    prompts,
    agentFrames,
    frames,
    agentMarkers,
    markers,
    agentNotifications,
    agentDocumentCollections,
    agentConnections,
    notifications,
    documentCollections,
    connections,
    agentType,
    catalog,
    catalogs,
    isActive,
    isDisabled,
    dictionaries,
    dictionary,
    agentMemoryType,
    memoryLimit,
    setMemoryLimit,
    setAgentMemoryType,
    setName,
    setDetailsLevel,
    setTemperature,
    setPromptId,
    setAgentFrames,
    setAgentMarkers,
    setAgentNotifications,
    setAgentDocumentCollections,
    setAgentConnections,
    setAgentType,
    setCatalog,
    setIsActive,
    setDictionary,
    skills,
    setSkills,
    modelName,
    setModelName,
    reasoning,
    setReasoning,
    isDocumentPermission,
    isOrganizationsPermission,
    swarms,
    agentSwarms,
    setAgentSwarms,
    showAlert,
    templates,
    agentTemplates,
    setAgentTemplates,
    disableCollections,
    collectionTextWarning,
    auditExecution,
    setAuditExecution
}) {

    useEffect(() => {
    // Run in console:  debugAgentFrames()
    window.debugAgentFrames = () => {
        console.log('agentFrames:', agentFrames);
        if (Array.isArray(agentFrames)) console.table(agentFrames);
    };
    return () => { delete window.debugAgentFrames; };
    }, [agentFrames]);
    
    return (
        <>
            <h4 className='h4-title'>Main Settings</h4>

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Name</div>
                    <div className="small-font">Enter agent name</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomInput
                        id="agent-name"
                        label="Agent Name"
                        placeholder="Enter agent name"
                        icon={<i className="fa-solid fa-user"></i>}
                        value={name}
                        onChange={(id, value) => setName(value)}
                        disabled={isDisabled}
                    />
                </div>
            </div>
            {isOrganizationsPermission && (
                <>
                    <div className="input-block d-flex flex-row justify-between">
                        <div className="input-description">
                            <div className="input-title">Model</div>
                            <div className="small-font">Select AI model</div>
                        </div>
                        <div className="align-wrapper d-flex align-center">
                            <CustomSelect
                                id="agent-model-select"
                                label="Models"
                                options={[
                                    {value: 'gpt-4.1-mini', label: 'gpt-4.1-mini'},
                                    {value: 'gpt-4.1', label: 'gpt-4.1'},
                                    {value: 'gpt-5-mini', label: 'gpt-5-mini'},
                                    {value: 'gpt-5', label: 'gpt-5'},
                                    {value: 'gpt-5.1', label: 'gpt-5.1'},
                                    {value: 'gpt-5.2', label: 'gpt-5.2'},
                                ]}
                                value={modelName}
                                multiSelect={false}
                                onChange={(val) => setModelName(val)}
                                disabled={isDisabled}
                            />
                        </div>
                    </div>
                    {['gpt-5', 'gpt-5-mini', 'gpt-5.1', 'gpt-5.2'].includes(modelName) && (
                        <div className="input-block d-flex flex-row justify-between">
                            <div className="input-description">
                                <div className="input-title">Reasoning</div>
                                <div className="small-font">Select AI reasoning</div>
                            </div>
                            <div className="align-wrapper d-flex align-center">
                                <CustomSelect
                                    id="agent-model-reasoning"
                                    label="Models"
                                    options={[
                                        {value: 'minimal', label: 'Minimal'},
                                        {value: 'low', label: 'Low'},
                                        {value: 'medium', label: 'Medium'},
                                        {value: 'high', label: 'High'},
                                    ]}
                                    value={reasoning}
                                    multiSelect={false}
                                    onChange={(val) => setReasoning(val)}
                                    disabled={isDisabled}
                                />
                            </div>
                        </div>
                    )}
                </>
            )}

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Agent Skills</div>
                    <div className="small-font">Select agent skills</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomSelect
                        id="agent-frames-select"
                        label="Agent Skills"
                        options={[
                            {value: 'SKILL:GEOLOCATION', label: 'Geolocation'},
                            {value: 'SKILL:PAGE', label: 'Static Page Generation'},
                            {value: 'SKILL:WEB_SEARCH', label: 'Web Search'},
                            {value: 'SKILL:WEB_SEARCH_HIGH', label: 'Web Search (High)'},
                            {value: 'SKILL:SCRAPE', label: 'Web Scraping (Text)'},
                            {value: 'SKILL:SCRAPE_HTML', label: 'Web Scraping (HTML)'},
                            {value: 'SKILL:IMAGE', label: 'Image Generation'},
                        ]}
                        value={skills}
                        multiSelect={true}
                        onChange={(val) => setSkills(val)}
                        disabled={isDisabled}
                    />
                </div>
            </div>

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Level of Details</div>
                    <div className="small-font">Select detalization of responses made by the agent</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomSelect
                        id="details-level-select"
                        label="Level of Details"
                        options={[
                            {value: 'BASIC', label: 'Basic response'},
                            {value: 'MIDDLE', label: 'Normal response'},
                            {value: 'FULL', label: 'Detailed response'},
                        ]}
                        value={detailsLevel}
                        multiSelect={false}
                        onChange={(val) => setDetailsLevel(val)}
                        disabled={isDisabled}
                    />
                </div>
            </div>
            {['gpt-4.1-mini', 'gpt-4.1'].includes(modelName) && (
                <div className="input-block d-flex flex-row justify-between">
                    <div className="input-description">
                        <div className="input-title">Temperature</div>
                        <div className="small-font">Set the temperature (0-100)</div>
                    </div>
                    <div className="align-wrapper d-flex align-center">
                        <CustomSlider
                            id="temperature-slider"
                            label="Temperature"
                            min={0}
                            max={100}
                            oneStep={1}
                            suffix=" %"
                            value={temperature}
                            onChange={(val) => setTemperature(val)}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
            )}

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Prompt</div>
                    <div className="small-font">Select a prompt</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomSelect
                        id="prompt-select"
                        label="Prompt"
                        options={(prompts || []).map(a => ({
                            value: a.id,
                            label: a.name
                        }))}
                        value={promptId}
                        multiSelect={false}
                        onChange={(val) => setPromptId(val)}
                        disabled={isDisabled}
                    />
                </div>
            </div>

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Agent Frames</div>
                    <div className="small-font">Select agent frames (optional)</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomSelect
                        id="agent-frames-select"
                        label="Agent Frames"
                        options={(frames || []).map((a) => ({
                            value: a.id,
                            label: a.name
                        }))}
                        value={agentFrames}
                        multiSelect={true}
                        onChange={(val) => setAgentFrames(val)}
                        disabled={isDisabled}
                    />
                </div>
            </div>

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Markers</div>
                    <div className="small-font">Select markers (optional)</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomSelect
                        id="agent-markers-select"
                        label="Markers"
                        options={(markers || []).map((a) => ({
                            value: a.id,
                            label: a.name
                        }))}
                        value={agentMarkers}
                        multiSelect={true}
                        onChange={(val) => setAgentMarkers(val)}
                        disabled={isDisabled}
                    />
                </div>
            </div>

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Agent Swarm</div>
                    <div className="small-font">Select collaborative agents (optional)</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomSelect
                        id="agent-swarm-select"
                        label="Agent Swarm"
                        options={(swarms || []).map((a) => ({
                            value: a.key,
                            label: a.name
                        }))}
                        value={agentSwarms}
                        multiSelect={true}
                        onChange={(val) => setAgentSwarms(val)}
                        disabled={isDisabled}
                    />
                </div>
            </div>

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Notifications</div>
                    <div className="small-font">Select notifications (optional)</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomSelect
                        id="notifications-select"
                        label="Notifications"
                        options={(notifications || []).map((a) => ({
                            value: a.id,
                            label: a.name
                        }))}
                        value={agentNotifications}
                        multiSelect={true}
                        onChange={(val) => setAgentNotifications(val)}
                        disabled={isDisabled}
                    />
                </div>
            </div>

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Type</div>
                    <div className="small-font">Select the agent type</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomSelect
                        id="type-select"
                        label="Type"
                        options={[
                            {value: 'SIMPLE', label: 'Simple'},
                            {value: 'RAG', label: 'RAG'},
                        ]}
                        value={agentType}
                        multiSelect={false}
                        onChange={(val) => setAgentType(val)}
                        disabled={isDisabled}
                    />
                </div>
            </div>
          {agentType === 'RAG' && (
            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Collections</div>
                    <div
                        className="small-font"
                        style={{ color: collectionTextWarning ? '#b00020' : 'inherit' }}

                    >
                        {collectionTextWarning || "Select collections (optional)"}
                    </div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomSelect
                        id="collections-select"
                        label="Collections"
                        options={(documentCollections || []).map((a) => ({
                            value: a.id,
                            label: a.name
                        }))}
                        value={agentDocumentCollections}
                        multiSelect={true}
                        maxItems={2}
                        onChange={(val) => setAgentDocumentCollections(val)}
                        disabled={isDisabled || disableCollections}
                    />
                </div>
            </div>
          )}

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Connections</div>
              <div className="small-font">Select connections (optional)</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomSelect
                id="connections-select"
                label="Connections"
                options={(connections || []).map((a) => ({
                  value: a.id,
                  label: a.name
                }))}
                value={agentConnections}
                multiSelect={true}
                maxItems={100}
                onChange={(val) => setAgentConnections(val)}
                disabled={isDisabled}
              />
            </div>
          </div>

            {isDocumentPermission && (
                <div className="input-block d-flex flex-row justify-between">
                    <div className="input-description">
                        <div className="input-title">Product Catalog</div>
                        <div className="small-font">Select the product catalog</div>
                    </div>
                    <div className="align-wrapper d-flex align-center">
                        <CustomSelect
                            id="catalog-select"
                            label="Product Catalog"
                            options={[
                                {value: null, label: "Not Selected"},
                                ...(catalogs || []).map((item) => ({value: item.id, label: item.name}))
                            ]}
                            value={catalog}
                            multiSelect={false}
                            onChange={(val) => setCatalog(val)}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
            )}

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Dictionaries</div>
                    <div className="small-font">Select dictionary (optional)</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomSelect
                        id="dictionary-select"
                        label="Dictionaries"
                        options={dictionaries.map(d => ({value: d.id, label: d.title}))}
                        value={dictionary}
                        multiSelect={false}
                        onChange={val => {
                            setDictionary(val)
                        }}
                        disabled={isDisabled}
                        key={dictionary}
                    />
                </div>
            </div>

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Templates</div>
                    <div className="small-font">Select template (optional)</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomSelect
                        id="template-select"
                        label="Templates"
                        options={templates.map(d => ({value: d.id, label: d.name}))}
                        value={agentTemplates}
                        multiSelect={true}
                        onChange={val => {
                            setAgentTemplates(val)
                        }}
                        disabled={isDisabled}
                    />
                </div>
            </div>

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Active</div>
                    <div className="small-font">Set the agent to be active or inactive</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomToggle
                        id="active-toggle"
                        label={isActive ? 'Active' : 'Inactive'}
                        checked={isActive}
                        onChange={(id, value) => setIsActive(value)}
                        disabled={isDisabled}
                    />
                </div>
            </div>

            <div className="input-block d-flex flex-row justify-between">
                <div className="input-description">
                    <div className="input-title">Memory Type</div>
                    <div className="small-font">Select agent memory type (optional)</div>
                </div>
                <div className="align-wrapper d-flex align-center">
                    <CustomSelect
                        id="memory-type"
                        label="Memory Type"
                        options={[
                            {value: "MESSAGE_COUNT", label: "By Messages"},
                            {value: "TIME_WINDOW", label: "By Time"},
                        ]}
                        value={agentMemoryType}
                        multiSelect={false}
                        onChange={(val) => setAgentMemoryType(val)}
                        disabled={isDisabled}
                    />
                </div>
            </div>

          <div className="input-block d-flex flex-row justify-between">
            <div className="input-description">
              <div className="input-title">Audit Execution</div>
              <div className="small-font">Set the audit execution enable or disable</div>
            </div>
            <div className="align-wrapper d-flex align-center">
              <CustomToggle
                id="active-toggle"
                label={auditExecution ? 'Enable' : 'Disabled'}
                checked={auditExecution}
                onChange={(id, value) => setAuditExecution(value)}
                disabled={isDisabled}
              />
            </div>
          </div>

            {agentMemoryType && (
                <div className="input-block d-flex flex-row justify-between">
                    <div className="input-description">
                        <div className="input-title">Memory Limit</div>
                        <div className="small-font">
                            {agentMemoryType === "MESSAGE_COUNT"
                                ? "Enter the number of messages the agent will remember"
                                : "Enter the number of hours the agent will remember"}
                        </div>
                    </div>
                    <div className="align-wrapper d-flex align-center">
                        <CustomNumberInput
                            id="memory-limit-input"
                            value={memoryLimit}
                            max={200}
                            min={0}
                            onChange={(val) => setMemoryLimit(val)}
                            disabled={isDisabled}
                        />
                    </div>
                </div>
            )}
        </>
    );
}

export default AgentSettings;